<div class="dialog-content-wrapper" style="max-width: 1000px;">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">Text Widget Settings</span>
          <button mat-icon-button class="mat-icon-button white-fg"
                  (click)="dialogRef.close()"
                  aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0 pb-0" style="overflow-y: hidden;">
    <form class="addDialog" [formGroup]="form" fxLayout="column" fxFlex>
      <div class="container">
        <html-editor
        value="{{value}}"
        (change)="onValueChange($event)"
        style="margin-top: 24px; height: 100%;"
        ></html-editor>
      </div>
      <div class="mt-48">
        <mat-checkbox formControlName="showInWidget" name="inWidget" id="showInWidget">Show in tile</mat-checkbox>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button mat-raised-button
                    type="submit" 
                    [disabled]="((!form.valid) || (form.pristine)) && (!newValue)"
                    [mat-dialog-close]="1" 
                    (click)="save()"
                    class="save-button mat-accent"
                    aria-label="SAVE">
                SAVE
            </button>
        </div>
    </div>
</div>

